export default class GlobalBus {
  private static handlers: Map<string, ((data: any) => void)[]> = new Map();
  public static clear = GlobalBus.handlers.clear;

  public static emit(event: string, data?: any) {
    const handlers = GlobalBus.handlers.get(event) || [];
    handlers.forEach((h) => h(data));
  }

  public static on(event: string, handler: (data: any) => void) {
    const handlers = GlobalBus.handlers.get(event) || [];
    GlobalBus.handlers.set(event, [...handlers, handler]);
  }

  public static off(event: string, handler?: (data: any) => void) {
    if (!handler) {
      GlobalBus.handlers.delete(event);
    } else {
      const handlers = (GlobalBus.handlers.get(event) || []).filter(
        (existHandler) => existHandler != handler
      );
      GlobalBus.handlers.set(event, handlers);
    }
  }
}
